module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/chapel_sns_01-8bc98bf57f12a447c98bcea976ea29e7.jpg";